export function capitalizeFirstLetter(value?: string) {
  const trimmed = value?.trim();

  return trimmed
    ? trimmed.charAt(0).toUpperCase() + trimmed.slice(1)
    : undefined;
}
